module.exports = __webpack_public_path__ + "img/spa.dcb43af5.jpg";